/* ===============================
   SKNBODY HEADER JS (DESKTOP + MOBILE)
   - Desktop: Shop/Learn hover dropdowns (stable)
   - Mobile: Hamburger menu
   - Currency: Desktop + Mobile market switch
   =============================== */

$(function () {
  /* -------------------------------
     Flag display helper
  -------------------------------- */
  if (window.location.pathname.includes('/en-uk')) {
    $('body').addClass('path-en-uk');
    $('.hm_masket div img:nth-child(2)').css({ opacity: '1' });
    $('.M_shipping img:nth-child(2)').css({ opacity: '1' });
  }
/* ===============================
   DESKTOP: Shop / Learn dropdowns (reliable)
   =============================== */
$(function () {
  if (!window.matchMedia('(min-width: 751px)').matches) return;

  const $shopPopup = $('.desktop-only .hm_popup_shop');
  const $learnPopup = $('.desktop-only .hm_popup_learn');

  // Select the REAL nav items (not nth-child fragile)
  const $nav = $('.desktop-only .hm_nav');
  const $shopLink = $nav.find('a.hm_namI').first();   // Shop
  const $learnLink = $nav.find('.hm_namI').eq(3);     // Learn (4th item)

  let tShop, tLearn;

  const closeAll = () => {
    $shopPopup.removeClass('is-open');
    $learnPopup.removeClass('is-open');
  };

  const openShop = () => {
    clearTimeout(tShop);
    clearTimeout(tLearn);
    $learnPopup.removeClass('is-open');
    $shopPopup.addClass('is-open');
  };

  const openLearn = () => {
    clearTimeout(tShop);
    clearTimeout(tLearn);
    $shopPopup.removeClass('is-open');
    $learnPopup.addClass('is-open');
  };

  const closeShopDelay = () => {
    clearTimeout(tShop);
    tShop = setTimeout(() => $shopPopup.removeClass('is-open'), 120);
  };

  const closeLearnDelay = () => {
    clearTimeout(tLearn);
    tLearn = setTimeout(() => $learnPopup.removeClass('is-open'), 120);
  };

  // SHOP hover area = link + popup
  $shopLink.on('mouseenter', openShop).on('mouseleave', closeShopDelay);
  $shopPopup.on('mouseenter', openShop).on('mouseleave', closeShopDelay);

  // LEARN hover area = link + popup
  $learnLink.on('mouseenter', openLearn).on('mouseleave', closeLearnDelay);
  $learnPopup.on('mouseenter', openLearn).on('mouseleave', closeLearnDelay);

  // safety: close when leaving header region
  $('.desktop-only .header_main').on('mouseleave', closeAll);
});

  /* -------------------------------
     MOBILE: menu toggle
  -------------------------------- */
  let mliflag = true;

  $('#MMenuBtn, .menu_left').on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();

    const $btn = $('#MMenuBtn');
    const $line = $btn.find('.menu_line');
    const $popup = $('.Mmenu_popup');

    if (mliflag) {
      $line.css({ background: 'transparent' });
      $btn.addClass('menu_active');
      $popup.css({ height: '94vh' });
    } else {
      $line.css({ background: '#5d4e53' });
      $btn.removeClass('menu_active');
      $popup.css({ height: '0' });
    }
    mliflag = !mliflag;
  });

  $(document).on('click', function () {
    if (!mliflag) {
      $('#MMenuBtn').removeClass('menu_active');
      $('#MMenuBtn .menu_line').css({ background: '#5d4e53' });
      $('.Mmenu_popup').css({ height: '0' });
      mliflag = true;
    }
  });

  $('.Mmenu_popup').on('click', function (e) {
    e.stopPropagation();
  });

  /* -------------------------------
     Header scroll behavior
  -------------------------------- */
  let lastScrollTop = 0;

  $(window).on('scroll', function () {
    const Top = $(window).scrollTop();

    if (Top > 65) {
      $('.header_main').css({ position: 'fixed', top: 0 });
    } else {
      $('.header_main').css({ position: 'absolute', top: '100%' });
    }

    if (window.matchMedia('(max-width: 750px)').matches) {
      $('.Mheader_main').css({ position: 'fixed', top: 'var(--skn-ticker-h)' });
    }

    if (Top < lastScrollTop) {
      if (Top > 1) $('.To_top').fadeIn();
      else $('.To_top').fadeOut();
    } else {
      $('.To_top').fadeOut();
    }

    lastScrollTop = Top;
  });

  /* -------------------------------
     CURRENCY / MARKET SWITCH
  -------------------------------- */
  const form = document.getElementById('SKN_LocalizationForm');
  if (!form) return;

  const countryInput = form.querySelector('input[name="country_code"]');
  const langInput = form.querySelector('input[name="language_code"]');

  const langs = Array.isArray(window.SKN_LANGS) ? window.SKN_LANGS : [];
  const lower = (s) => String(s || '').toLowerCase();

  const pickLang = (country) => {
    if (!langs.length) return langInput ? langInput.value : 'en';

    if (country === 'GB') {
      return (
        (langs.find((l) => lower(l.iso_code) === 'en-gb') || {}).iso_code ||
        (langs.find((l) => lower(l.iso_code).includes('gb')) || {}).iso_code ||
        (langInput ? langInput.value : 'en')
      );
    }

    return (
      (langs.find((l) => lower(l.iso_code) === 'en') || {}).iso_code ||
      (langs.find((l) => lower(l.iso_code) === 'en-us') || {}).iso_code ||
      (langInput ? langInput.value : 'en')
    );
  };

  const safeRedirect = (country) => {
    window.location.href = country === 'GB' ? '/en-uk/' : '/';
  };

  const setMarket = (country) => {
    if (countryInput) countryInput.value = country;
    if (langInput) langInput.value = pickLang(country);

    try {
      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else form.submit();
    } catch (e) {
      form.submit();
    }

    setTimeout(() => safeRedirect(country), 400);
  };

  // DESKTOP currency
  const deskTrigger = document.getElementById('sknCurrencyTrigger');
  const deskMenu = document.getElementById('sknCurrencyMenu');

  if (deskTrigger && deskMenu) {
    deskTrigger.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      deskMenu.classList.toggle('is-open');
    });

    document.addEventListener('click', () => deskMenu.classList.remove('is-open'));
    deskMenu.addEventListener('click', (e) => e.stopPropagation());

    deskMenu.querySelectorAll('.skn_market_btn[data-market-country]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const country = btn.getAttribute('data-market-country');
        if (country) setMarket(country);
      });
    });
  }

  // MOBILE currency
  const mobTrigger = document.getElementById('M_currencyTrigger');
  const mobMenu = document.getElementById('M_currencyMenu');

  if (mobTrigger && mobMenu) {
    mobTrigger.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      mobMenu.classList.toggle('is-open');
    });

    document.addEventListener('click', () => mobMenu.classList.remove('is-open'));
    mobMenu.addEventListener('click', (e) => e.stopPropagation());

    mobMenu.querySelectorAll('.skn_market_btn[data-market-country]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const country = btn.getAttribute('data-market-country');
        if (country) setMarket(country);
      });
    });
  }
});
